<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="SystemVal" @change="ReSetPage" clearable placeholder="审核系统">
                    <el-option v-for="i in SystemList" :key="i.id" :label="i.system_name" :value="i.id"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger" @click="Delete('')">批量删除</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" @selection-change="TabChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="group_name" label="名称" min-width="100"></el-table-column>
            <el-table-column prop="description" label="描述" min-width="100"></el-table-column>
            <el-table-column prop="item_count" label="收集项" min-width="100"></el-table-column>
            <el-table-column prop="systems" label="所属项目" min-width="100">
                <template slot-scope="scope">
                    <div class="BtnHead FlexWrap">
                        <el-tag v-for="item in scope.row.systems" :key="item.system_sub_id" type="success">
                            {{item.system_sub_name || item.system_name}}
                        </el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="关闭/开启" min-width="100">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ddd"
                    :active-value="1" :inactive-value="0" @change="ToggleStatus(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column prop="update_time" label="创建时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="复制" placement="top-start">                        <i class="NavIcon el-icon-document-copy"@click="DataCopy(scope.row.id)"></i>                    </el-tooltip>                        
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                          <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">                          
                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增资料收集':'修改资料收集'" :visible.sync="NewData.NewBlon" width="40%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">所属系统：</div>
                <el-cascader class="Wid" size="medium" v-model="NewData.system_sub_id" :options="SystemList" :props="{multiple: true,value:'id',label:'system_name',children:'child'}" clearable></el-cascader>
                <!-- <el-select class="Wid" size="medium" v-model="NewData.system_ids" placeholder="所属系统" multiple>
                    <el-option v-for="item in SystemList" :key="item.id" :label="item.system_name" :value="item.id"></el-option>
                </el-select> -->
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">名称：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入名称" v-model="NewData.group_name"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">状态：</div>
                    <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">描述：</div>
                <el-input class="Wid" size="medium" type="textarea" :rows="2" placeholder="请输入系统描述" v-model="NewData.description"></el-input>
            </div>
            <div class="DisFlex">
                <el-transfer
                    filterable
                    :filter-method="filterMethod"
                    filter-placeholder="请输入字段名"
                    target-order="push"
                    v-model="NewData.item_ids"
                    :data="FoldList"
                    :titles="['未选择资料','已选择资料']">
                    <el-button class="transfer-footer" slot="left-footer" size="mini" style="opacity: 0;cursor: default;"></el-button>
                    <el-button class="transfer-footer" slot="right-footer" size="mini" @click="OpenSort">排序</el-button>
                  </el-transfer>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="选中项排序" :visible.sync="SortBlon" width="40%" class="BorderRadius">
            <!-- 已选择排序预览 -->
            <div class="SortDis">
                <div class="SortHead">
                    <div v-for="(item,index) in SortArr" :key="item" class="SortItem" :class="{'SortAct': selectedIndex === index}" @click="selectedIndex = index">
                        {{ getLabelById(item) }}
                    </div>
                </div>
                <div class="SortDis">
                    <el-button icon="el-icon-arrow-up" circle  @click="moveUp" size="mini" type="primary"></el-button>
                    <el-button icon="el-icon-arrow-down" circle @click="moveDown" size="mini" type="primary"></el-button>
                </div>
            </div>
            <div slot="footer">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SortSuc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                SystemVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                SeleId:[],
                Type:'Add',
                NewData:{
                    id:'',
                    NewBlon:false,
                    group_name:"",
                    description:"",
                    system_sub_id:"",
                    item_ids:[],
                    status:0,
                },
                SystemList:'',
                FoldList:"",
                selectedIndex:-1,
                SortBlon:false,
                SortArr:[],
                filterMethod(query, item) {
                  return item.field_label.indexOf(query) > -1;
                },
                FoldType: [
                        {"value": "text","label": "单行文本"},
                        {"value": "textarea","label": "多行文本"},
                        {"value": "select","label": "下拉框"},
                        {"value": "radio","label": "单选框"},
                        {"value": "checkbox","label": "多选框"},
                        {"value": "date","label": "日期"},
                        {"value": "file","label": "上传文件"},
                        {"value": "area","label": "区域选择"},
                        {"value": "img_text","label": "图片描述"},
                        {"value": "cascader","label": "二级联动"},
                ],
            };
        },
        mounted() {
            this.SystemList = JSON.parse(this.$Tools.localData("SystemMenu"));
            this.GetData();
            this.GetFold();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/info_collection_group/index',{
                    keyword:this.SearchVal,
                    system_id:this.SystemVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetFold(){
                this.$get('/admin/info_collection_item/index',{
                    keyword:this.SearchVal,
                    page:1,
                    page_size:1000,
                    status:1,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.FoldList = res.data.list.map(item=>{
                            return {
                                ...item,
                                key: item.id,
                                label: item.field_label+' | '+this.FoldType.filter(i=>i.value == item.field_type)[0].label
                            }
                        });
                    }
                })
            },
            TabChange(val){
                this.SeleId = val.map(item => item.id);
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.$get('/admin/info_collection_group/detail',{
                        id:row.id,
                    }).then(res=>{
                        if(res){
                            this.NewData.item_ids = res.data.items.map(i => i.id);
                            this.NewData.system_sub_id = res.data.system_sub_data;
                            this.NewData.description = res.data.description;
                            this.NewData.group_name = res.data.group_name;
                            this.NewData.status = res.data.status;
                        }
                    })
                }else{
                    this.Type='Add';
                    this.NewData.id="";
                }
                this.NewData.NewBlon = true;
            },
            OpenSort(){
                this.SortArr = JSON.parse(JSON.stringify(this.NewData.item_ids));
                this.selectedIndex = -1;
                this.SortBlon = true;
            },
            // 根据ID获取显示文本
            getLabelById(id) {
                const item = this.FoldList.find(i => i.id == id);
                return item ? item.label : id;
            },
            // 上移
            moveUp() {
                if (this.selectedIndex <= 0){return};
                const arr = this.SortArr;
                [arr[this.selectedIndex], arr[this.selectedIndex - 1]] = [arr[this.selectedIndex - 1], arr[this.selectedIndex]];
                this.selectedIndex--;
            },
            // 下移
            moveDown() {
                const arr = this.SortArr;
                if (this.selectedIndex >= arr.length - 1){return};
                [arr[this.selectedIndex], arr[this.selectedIndex + 1]] = [arr[this.selectedIndex + 1], arr[this.selectedIndex]];
                this.selectedIndex++;
            },
            SortSuc(){
                this.NewData.item_ids = this.SortArr;
                this.SortArr = [];
                this.SortBlon = false;
            },
            Suc(){
                var url = this.Type=='Add'?'/admin/info_collection_group/save':'/admin/info_collection_group/update'
                this.$post(url,this.NewData).then(res=>{
                    if(res){
                        this.$message.success("操作成功");
                        this.ReSetPage();
                    }
                })
                this.$Tools.ResetData(this.NewData)
            },
            ToggleStatus(row){
                this.$post('/admin/info_collection_group/toggleStatus',{
                    ids:[row.id],
                    status:row.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功!");
                        this.GetData();
                    }else{
                        row.status = !row.status;
                    }
                })
            },
            DataCopy(id){
                this.$post('/admin/info_collection_group/copy',{
                    id:id,
                }).then(res=>{
                    if(res){
                        this.$message.success("复制成功!");
                        this.GetData();
                    }
                })
            },
            Delete(id) {
                var Ids = id!=""?[id]:this.SeleId;
                this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/info_collection_group/delete',{
                        ids:Ids,
                    }).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    .DisFlex{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .SortDis{
        display: flex;
        align-items: center;
    }
    .SortHead{
        width:90%;
        padding:10px;
        max-height:350px;
        overflow-y:auto;
    }
    .SortItem{
        padding:6px 10px;
        background:#f5f7fa;
        margin-bottom:5px;
        border-radius:4px;
        cursor:pointer;
    }
    .SortAct {
        background: #409eff !important;
        color: #fff;
    }
</style>
